import React, { useContext } from "react";
import { View, Text, ScrollView, StyleSheet } from "react-native";
import {
  BORDER_STYLES,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";

import { DIMENSION_HEIGHT, DIMENSION_WIDTH } from "app/utils/common";
import { Crop } from "../../models/crop";
import RoundImageWithName from "app/components/reusable/RoundImageWithName";
import { CenterModal } from "app/components/reusable/CenterModal";
import RoundAddButton from "../common/RoundAddBtn";
import { ResponsiveContext } from "app/context/ResponsiveUIContext";

interface Props {
  isVisible: boolean;
  handleClose: () => void;
  crops: Crop[];
  onCropSelect: (crop: Crop) => void;
  onAddNewCropClick: () => void;
  heading: string;
  description?: string;
}

const SelectCropModal = ({
  heading,
  description,
  isVisible,
  handleClose,
  crops,
  onCropSelect,
  onAddNewCropClick,
}: Props) => {
  const { mediaStyles } = useContext(ResponsiveContext);

  return (
    <CenterModal
      isVisible={isVisible}
      onClose={handleClose}
      style={{
        width: "95%",
        height: "75%",
      }}
    >
      <View style={[COMMON_STYLES.fullWidth, COMMON_STYLES.fullHeight]}>
        <Text
          style={[
            TYPOGRAPHY.HEADING3,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral90,
          ]}
        >
          {heading}
        </Text>
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral70,
            COMMON_STYLES["mt1/2"],
          ]}
        >
          {description}
        </Text>

        <ScrollView
          style={COMMON_STYLES.flex1}
          contentContainerStyle={COMMON_STYLES["pl0.5"]}
        >
          <View
            style={[
              COMMON_STYLES.row,
              COMMON_STYLES.flexWrap,
              COMMON_STYLES.mt2,
              mediaStyles({
                desktopStyle: styles["gap5/2"],
                mobileStyle: styles["gap1/4"],
              }),
            ]}
          >
            {crops.map((crop) => (
              <RoundImageWithName
                key={crop.id}
                name={crop.name}
                imgUrl={crop.image_url}
                handleItemClick={() => onCropSelect(crop)}
                imageStyle={[
                  COMMON_STYLES.b1,
                  BORDER_STYLES.borderNeutral20,
                  styles.imageTile,
                ]}
                textStyle={mediaStyles({ mobileStyle: COMMON_STYLES["mb3/2"] })}
              />
            ))}
            <RoundAddButton
              onClick={onAddNewCropClick}
              ctaText={"Add more crops"}
            />
          </View>
        </ScrollView>
      </View>
    </CenterModal>
  );
};

const styles = StyleSheet.create({
  imageTile: {
    width: 100,
    height: 100,
    borderRadius: 50,
  },
  "gap5/2": {
    gap: 40,
  },
  "gap1/4": {
    gap: 4,
  },
});

export default SelectCropModal;
